// extracted by mini-css-extract-plugin
export default {"container":"BlogView_container__cVqWb","responsiveiframe":"BlogView_responsiveiframe__NN5u1"};